var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.currentUser && !_vm.isCurrentUserOwner)?_c('a',{staticClass:"like-btn",class:{active: _vm.likedByMe},on:{"click":_vm.toggleLike}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-thumb-up")]),_c('span',[_vm._v("いいね！")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }